import {
  CLIENT_ENTRY_PATH,
  canonical_client_path,
  clean_client_path,
  is_client_entry_path,
  is_client_flow_path,
  parse_cnpj_from_path,
} from './client-paths'
import { driver_path, is_driver_flow_path } from './driver-paths'
import { EV_ENTRY_PATH, EV_STATIONS_PATH, is_ev_flow_path } from './ev-paths'

export interface EntryRouteState {
  client_phone: boolean
  client_auth: boolean
  client_cnpj: string | null
  driver_phone: boolean
  driver_auth: boolean
}

function clean_path(path: string): string {
  const without_query = String(path || '').split('?')[0] ?? ''
  return (without_query.split('#')[0] ?? '') || '/'
}

function path_suffix(path: string): string {
  const query_index = path.indexOf('?')
  const hash_index = path.indexOf('#')
  if (query_index === -1 && hash_index === -1) return ''
  if (query_index === -1) return path.slice(hash_index)
  if (hash_index === -1) return path.slice(query_index)
  return path.slice(Math.min(query_index, hash_index))
}

function has_pin_query(path: string): boolean {
  const suffix = path_suffix(path)
  if (!suffix.startsWith('?')) return false
  const hash_index = suffix.indexOf('#')
  const search = hash_index === -1 ? suffix : suffix.slice(0, hash_index)
  return new URLSearchParams(search).has('pin')
}

export function resolve_entry_route(path: string, state: EntryRouteState): string {
  let next_path = path
  const original_requested_path = clean_path(path)
  const root_cnpj = parse_cnpj_from_path(path)
  const pinned_client_root = original_requested_path === '/'
    && has_pin_query(path)
    && !!state.client_cnpj

  if (original_requested_path === '/') {
    next_path = root_cnpj || pinned_client_root
      ? `${CLIENT_ENTRY_PATH}${path_suffix(path)}`
      : `${driver_path('entry', '/ofertas')}${path_suffix(path)}`
  }

  if (is_client_flow_path(next_path)) next_path = canonical_client_path(next_path)
  const explicit_cnpj = parse_cnpj_from_path(next_path)
  const client_scope_matches = !explicit_cnpj || state.client_cnpj === explicit_cnpj

  if (is_driver_flow_path(next_path)) {
    const suffix = path_suffix(next_path)
    const entry_path = driver_path('entry', next_path)
    if (clean_path(next_path) !== entry_path && (!state.driver_phone || !state.driver_auth)) {
      return `${entry_path}${suffix}`
    }
    if (clean_path(next_path) === entry_path && state.driver_phone && state.driver_auth) {
      return `${driver_path('offers', next_path)}${suffix}`
    }
    return next_path
  }

  if (is_ev_flow_path(next_path)) {
		const suffix = path_suffix(next_path)
		if (clean_path(next_path) === EV_STATIONS_PATH && (!state.driver_phone || !state.driver_auth)) {
			return `${EV_ENTRY_PATH}${suffix}`
		}
		if (clean_path(next_path) === EV_ENTRY_PATH && state.driver_phone && state.driver_auth) {
			return `${EV_STATIONS_PATH}${suffix}`
		}
		return next_path
	}

  if (is_client_flow_path(next_path)
    && clean_client_path(next_path) !== CLIENT_ENTRY_PATH
    && (!state.client_phone || !state.client_cnpj || !state.client_auth || !client_scope_matches)) {
    return `${CLIENT_ENTRY_PATH}${path_suffix(next_path)}`
  }
  if (is_client_entry_path(next_path)
    && state.client_phone
    && state.client_cnpj
    && state.client_auth
    && client_scope_matches) {
    return `/combustiveis${path_suffix(next_path)}`
  }
  return next_path
}
